import { render, staticRenderFns } from "./RegisterAnnualConfirm.vue?vue&type=template&id=7a7dc052&"
import script from "./RegisterAnnualConfirm.vue?vue&type=script&lang=js&"
export * from "./RegisterAnnualConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports